import React from 'react';
import PropTypes from 'prop-types';
import { GetApp as DownloadIcon } from '@material-ui/icons';
import styled from 'styled-components';
import { SecondaryButton, SurfaceCard } from '../../../shared/ui';
import { lightTheme as theme } from '../../../shared/theme';
import { formatarDataHora } from '../../../shared/utils/dateFormatters';

const ReportDownloadIcon = styled(DownloadIcon)`
    font-size: 14px !important;
`;

const SectionCard = styled(SurfaceCard)`
    width: 100%;
`;

const CardTitle = styled.h3`
    margin: 0 0 14px;
    font-size: 16px;
    font-weight: 700;
    color: ${theme.colors.primary};
`;

const HistoryList = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
`;

const HistoryEntry = styled.div`
    border: 1px solid ${theme.colors.gray200};
    border-radius: 10px;
    background: ${theme.colors.gray50};
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const EntryHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    flex-wrap: wrap;
`;

const EntryDate = styled.span`
    font-size: 12px;
    color: ${theme.colors.textMuted};
    font-weight: 600;
`;

const EntryText = styled.div`
    color: ${theme.colors.text};
    font-size: 14px;
    line-height: 1.5;

    .description {
        color: ${theme.colors.textSecondary};
        margin-top: 4px;
    }
`;

const EmptyText = styled.p`
    margin: 0;
    color: ${theme.colors.textMuted};
    font-size: 14px;
`;

const DownloadError = styled.p`
    margin: 0;
    color: ${theme.colors.danger};
    font-size: 13px;
`;

const EmptyValue = '--';

function EquipmentHistorySection({
    sectionTitle,
    reports,
    emptyMessage,
    downloadLabel,
    onDownloadReport,
    downloadError,
}) {
    return (
        <SectionCard padding={20}>
            <CardTitle>{sectionTitle}</CardTitle>
            {downloadError ? <DownloadError>{downloadError}</DownloadError> : null}

            {!Array.isArray(reports) || reports.length === 0 ? (
                <EmptyText>{emptyMessage}</EmptyText>
            ) : (
                <HistoryList>
                    {reports.map((report, index) => (
                        <HistoryEntry
                            key={`${report?.nome_arquivo || report?.nome || 'report'}-${index}`}
                        >
                            <EntryHeader>
                                <EntryDate>{formatarDataHora(report?.created_at)}</EntryDate>
                                <SecondaryButton
                                    type='button'
                                    size='sm'
                                    startIcon={<ReportDownloadIcon />}
                                    disabled={!report?.nome_arquivo}
                                    onClick={() => onDownloadReport(report?.nome_arquivo)}
                                >
                                    {downloadLabel}
                                </SecondaryButton>
                            </EntryHeader>

                            <EntryText>
                                <div>{report?.nome || EmptyValue}</div>
                                <div className='description'>{report?.descricao || EmptyValue}</div>
                            </EntryText>
                        </HistoryEntry>
                    ))}
                </HistoryList>
            )}
        </SectionCard>
    );
}

EquipmentHistorySection.propTypes = {
    sectionTitle: PropTypes.string.isRequired,
    reports: PropTypes.arrayOf(PropTypes.object),
    emptyMessage: PropTypes.string.isRequired,
    downloadLabel: PropTypes.string.isRequired,
    onDownloadReport: PropTypes.func.isRequired,
    downloadError: PropTypes.string,
};

EquipmentHistorySection.defaultProps = {
    reports: [],
    downloadError: '',
};

export default EquipmentHistorySection;
